import { defineStore } from 'pinia'
import http from './http'
import { Response } from '@/types'

export const useDictStore = defineStore('dict', {
  state() {
    return {
      dictMap: {}
    }
  },
  actions: {
    async dict() {
      return http.request<any, Response<any>>('/const/all', 'GET').then(async (response) => {
        if (response.code === 200) {
          this.dictMap = response.data
          let customerDictPro = response.data.customerDict.map((item) => {
            return { label: item.label + '#' + item.value, value: item.value }
          })
          this.dictMap.customerDictPro = customerDictPro
          return response.data
        } else {
          return Promise.reject(response)
        }
      })
    }
  }
})
